import { Component, effect, inject, signal } from '@angular/core';
import { LenderCardComponent } from './components/lender-card.component';
import { LenderContactFormComponent } from './components/lender-contact-form.component';
import { CommonModule } from '@angular/common';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ContactFormComponent } from './components/contact-form.component';
import { Lender } from '@/models/bank-models.model';
import { LenderContactsService } from '@/services/api/lender-contacts.service';
import { LendersService } from '@/services/api/lenders.service';

@Component({
    selector: 'app-lender-contacts',
    imports: [
      CommonModule,
      DataViewModule,
      DialogModule,
      ButtonModule,
      ToastModule,
      LenderCardComponent,
      LenderContactFormComponent,
      ContactFormComponent
    ],
    template: `
    <p-dataView #dv [value]="lenders()" [layout]="layout">
    <ng-template #header>
        <div class="flex justify-content-end">
            <button pButton pRipple icon="pi pi-plus" label="Add Lender Contact" class="p-button-rounded p-button-text p-button-success" (click)="onAddLender()"></button>
        </div>
    </ng-template>
    <ng-template #list let-lenders>
        <div class="grid grid-nogutter">
            <div class="col-12" *ngFor="let lender of lenders; let first = first" class="col-12">
                <div class="p-3 border-round shadow-2 flex align-items-center surface-card">
                    <div style="width:48px;height:48px;border-radius:10px" class="bg-teal-100 inline-flex align-items-center justify-content-center mr-3">
                        <img *ngIf="!isGeneric(lender)" class="block xl:block mx-auto border-round w-full" [src]="'https://spexisstorage.blob.core.windows.net/bank-logos/' + lender.LenderID + '.png'" [alt]="lender.LenderID" />
                        <i *ngIf="isGeneric(lender)" class="pi pi-building-columns text-teal-600 text-3xl"></i>
                    </div>
                    <div>
                        <span class="text-900 text-xl font-medium mb-2">{{ lender.Title }}</span>
                        <p class="mt-1 mb-0 text-600 font-medium text-sm">{{ getSubtitle(lender) }}</p>
                    </div>
                    <div class="ml-auto">
                        <button pButton pRipple icon="pi pi-pencil" class="p-button-text p-button-plain p-button-rounded" (click)="onSelectLender(lender)"></button>
                    </div>
            </div>
            </div>
        </div>
    </ng-template>
    <ng-template #grid let-lenders>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <app-lender-card *ngFor="let lender of lenders" class=" mb-0 md:col-6" [lender]="lender" [selectable]="true" (selectLender)="onSelectLender($event)"></app-lender-card>
        </div>
    </ng-template>
</p-dataView>
<p-dialog header="Edit Contacts" [modal]="true"   [(visible)]="dialog">
    <app-lender-contact-form></app-lender-contact-form>
</p-dialog>
<p-dialog header="Add Lender Contact" [modal]="true"  [(visible)]="newDialogVisible">
    <app-contact-form (close)="onAddLenderDialogClose()"></app-contact-form>
</p-dialog>

<p-dialog header="Add New Lender" [modal]="true"  [(visible)]="newLenderDialogVisible">
    
</p-dialog>
<p-toast></p-toast>


    `
})
export class LenderContactsComponent {
  private lenderContactsService = inject(LenderContactsService);
  private lenderService = inject(LendersService);
  layout: 'grid' | 'list' = 'grid';
  generics = [100,133]
  dialogVisible = signal<boolean>(false);
  newDialogVisible = false;
  newLenderDialogVisible = false;
  lenders= signal<Lender[]>([]);
  allLenders= signal<Lender[]>([]);

  constructor() {
    this.lenderContactsService.getLenderContacts();

    effect(() => {
      const lenders = this.lenderContactsService.lenders();
      if (lenders.length > 0) {
        this.sortLenders(lenders);
        this.allLenders.set(lenders.sort((a, b) => a.Title.localeCompare(b.Title)));
      }
    });

    effect(() => {
      const dialogVisible = this.lenderContactsService.dialogVisible();
      if (dialogVisible) {
        this.dialogVisible.set(dialogVisible);
      }
    });
    effect(() => {
      const visible = this.dialogVisible();
      if (visible !== null) {
        
      }
    });
  }

  set dialog(visible: boolean) {
    this.dialogVisible.set(visible);
  }

  get dialog(): boolean {
    return this.dialogVisible();
  }

  sortLenders(lenders: Lender[]) {
    if(lenders.length > 0) {
      const sorted = lenders.filter(lender => lender.LenderContacts?.length && lender.LenderContacts.length > 0).sort((a, b) => a.Title.localeCompare(b.Title));
      this.lenders.set(sorted);
    }
  }

  isGeneric(lender: Lender) {
    return this.generics.includes(lender.LenderID);
  }

  getSubtitle(lender: Lender) {
    if (lender.LenderContacts?.length === 1) {
      if (lender.LenderContacts[0].contactFirstName && lender.LenderContacts[0].contactLastName) {
      return lender.LenderContacts[0].contactFirstName + ' ' + lender.LenderContacts[0].contactLastName;
    } else { return '1 contact'} 
  }

    return `${lender.LenderContacts?.length} contacts`;
  }

  onSelectLender(lender: Lender) {
    this.lenderContactsService.selectedLender.set(lender);
    this.lenderContactsService.dialogVisible.set(true);
    this.dialogVisible.set(true);
  }

  onAddLender() {
    this.newDialogVisible = true;
    this.lenderService.selectedLender.set(null);
  }

  onAddLenderDialogClose() {
    this.newDialogVisible = false;
  }

}
